import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        name: ''
      },
      rules: {
        name: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        flag: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, id, name, flag;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  id = datas.id, name = datas.name, flag = datas.flag;
                  _this.formData = {
                    id: id,
                    name: name,
                    flag: flag
                  };

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api.divisionSave(data).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success(_this2.formData.id ? '修改成功' : '添加成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};